import { createSlice } from '@reduxjs/toolkit';

import { Voltage } from '../../entities/Voltage';
import { AppError } from '../../entities/Errors';

import { getVoltageList } from './voltage.action';

interface VoltageState {
  loading: boolean;
  error: null | AppError;
  voltages: Voltage[];
}

const initialState = {
  loading: false,
  error: null,
  voltages: [],
} as VoltageState;

export const VoltageSlice = createSlice({
  name: 'voltage',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getVoltageList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVoltageList.fulfilled, (state, action) => {
        state.loading = false;
        state.voltages = action.payload.data;
      })
      .addCase(getVoltageList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default VoltageSlice.reducer;
